import { render } from "./AccountTypesView.vue?vue&type=template&id=042e6a16"
import script from "./AccountTypesView.vue?vue&type=script&lang=js"
export * from "./AccountTypesView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__